import React from 'react';
import { TextEnter } from './TextEnter';
import type { InitialDraft } from '../shared';
import './TextCapture.css';

export interface TextCaptureProps {
  taskName: string;
  prompt: string;
  onSubmit: (text: string, file: File | null) => void;
  onSaveDraft: (text: string, file: File | null) => void;
  onClose: () => void;
  initialText?: string;
  initialDraft?: InitialDraft;
}

export const TextCapture: React.FC<TextCaptureProps> = ({
  taskName,
  prompt,
  onSubmit,
  onSaveDraft,
  onClose,
  initialText,
  initialDraft,
}) => {
  // Reconstruct File from draft blob if available
  const draftFile = initialDraft?.mediaBlobs.length
    ? new File([initialDraft.mediaBlobs[0]], 'draft-attachment', { type: initialDraft.mediaBlobs[0].type })
    : undefined;

  return (
    <TextEnter
      taskName={taskName}
      prompt={prompt}
      onSubmit={onSubmit}
      onSaveDraft={onSaveDraft}
      onClose={onClose}
      initialText={initialDraft?.textContent || initialText}
      initialFile={draftFile}
    />
  );
};
